export interface ControllerListItem {
  controller_id: string
  controller_name: string | null
  company_id: string | null
  app_type: string | null
}

export const APP_TYPES = ['Sitka', 'Acacia', 'Baobab', 'Ceiba'] as const
export type AppType = (typeof APP_TYPES)[number]

export interface ControllerFormFields {
  controller_id: string
  company_id: string
  app_type: string
  controller_name: string
  env: 'prod' | 'dev'
  capacity: string
}

export interface ControllerDetail {
  controller_id: string
  company_id: string | null
  app_type: string | null
  controller_name: string | null
  env: string | null
  capacity: string | null
  [key: string]: unknown
}
